













import { Component, Vue ,Watch} from "vue-property-decorator"; 
import AdminSidebar from '../components/admin/adminSidebar.vue';
import AdminContent from '../components/admin/AdminContent.vue';
import { store, TextPermission, StoreState, AppSettings, HellospokeUser } from '../store';
import { mapState } from 'vuex';
import axios from  'axios';
import Sidebar from '../components/Sidebar.vue';
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js";
import QuickCall from '../components/QuickCall.vue';


declare interface AdminData {
		users: HellospokeUser[];
  }
  

@Component({
    components: {
        Sidebar,AdminSidebar,AdminContent ,QuickCall
    },
  
    computed: {
			...mapState({
				'jwt': (state: StoreState) => state.account.jwt,
                'selectedAccount': (state: StoreState) => state.dashboard.admin.selectedAccount,
                'comapany_name':  (state: StoreState) => state.dashboard.admin.company_name,
                'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
                'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
                 userfirstname: (state: StoreState) => state.dashboard.userfirstname,
            })
        },
     
})
export default class Admin extends Vue {
    data() {
        return {
        sidebarIcons: '',
        users: [],
        phone_nums_dict: {}
            } as AdminData
    }

 	       async created() {
			//Make the API request to get the Hellospoke accounts from DB
            //Dummy response below
        
			return this.$store.dispatch('setAdminHellospokeAccounts');
            }
            get adminHellospokeAccounts() {
                return this.$store.state.account.admin_hellospoke_accounts;
            }

		public jwt!: string;

		@Watch('selectedAccount', {immediate: true})
		async getAccountUsers(selectedaccount) {
            //alert('getAccountUsers'+ JSON.stringify(id) )
            this.$store.commit('SET_ADMIN_LOADER',true);
            var id=selectedaccount.id;   
            this.$data.users = [];
            if (typeof id=== 'undefined'    ) return [];
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.jwt;
			return axios.get(`${AppSettings.API_HOST}admin/accounts/${id}/users`)
				.then(r => {  
                    this.$store.commit('SET_ADMIN_LOADER',false)
                     //alert('here is the response');
                    this.processResponse(r.data);
				})
				.catch(r => {
                    this.$store.commit('SET_ADMIN_LOADER',false)
					console.warn(r);
				});
        }

        processResponse(response) {
            const phone_nums_dict = {
                all: [],
                users: {}
            }
           const phone_nums =response.phone_numbers?  response.phone_numbers.data.numbers:"";
            const callflows = response.callflows? response.callflows.data:[];
            for(const callflow of callflows) {
                for(const number of callflow.numbers) {
                    if(phone_nums.hasOwnProperty(number)) {
                        if(callflow.owner_id) {
                            if(phone_nums_dict.users.hasOwnProperty(callflow.owner_id)) {
                                phone_nums_dict.users[callflow.owner_id].push(number);
                            }
                            else {
                                phone_nums_dict.users[callflow.owner_id] = [number];
                            }
                        }
                        else {
                            phone_nums_dict.all.push((number) as never);
                        }
                    }
                }
            }
            this.$data.phone_nums_dict = phone_nums_dict;
            this.$data.users = this.processUsers(response);
        }

         processUsers(result) {
            var response= result.docs;
            if (!response) return [];
            var kazoouserlist= result.users.data;

            response = response.filter(e => kazoouserlist.find(e1 => e1.username === e.username));

            const phone_nums_dict = JSON.parse(JSON.stringify(this.$data.phone_nums_dict));
            var managers_list= this.$data.users.length>0 ?this.$data.users:JSON.parse(JSON.stringify( response));
           
            
            for(const user of response) {
                if(!user.text_permissions) {
                    user.text_permissions = [];
                }
                   if(user.privilege_level)
                   user.priv_level=user.privilege_level;
                var kazoouser= kazoouserlist.find(e => e.username === user.username);
            //      if (typeof kazoouser!= "undefined")
                    
               var call_recarding_enabled= typeof kazoouser!= "undefined" && kazoouser.features
               && typeof kazoouser.features.find(e => e === 'call_recording')!= "undefined" && kazoouser.call_recording;
                if (!call_recarding_enabled || typeof call_recarding_enabled ==='undefined')
                        call_recarding_enabled = kazoouser.smartpbx && kazoouser.smartpbx.call_recording && kazoouser.smartpbx.call_recording.enabled;

                if (typeof call_recarding_enabled ==='undefined')
                    call_recarding_enabled=false;

                var call_recarding_outbound_onnet_enabled = (kazoouser.call_recording 
                                                              && kazoouser.call_recording.outbound 
                                                              &&  kazoouser.call_recording.outbound.onnet)!='undefined';
                var call_recarding_outbound_offnet_enabled =(kazoouser.call_recording 
                                                              && kazoouser.call_recording.outbound 
                                                              &&  kazoouser.call_recording.outbound.offnet)!='undefined';

                var call_recarding_inbound_onnet_enabled = (kazoouser.call_recording 
                                                              && kazoouser.call_recording.inbound 
                                                              &&  kazoouser.call_recording.inbound.onnet)!='undefined';
                var call_recarding_inbound_offnet_enabled = (kazoouser.call_recording 
                                                              && kazoouser.call_recording.inbound 
                                                              &&  kazoouser.call_recording.inbound.offnet)!='undefined';

                user.callrecord_internal=call_recarding_enabled && call_recarding_outbound_onnet_enabled 
                                            && call_recarding_inbound_onnet_enabled &&
                                             ( kazoouser.call_recording.outbound.onnet.enabled 
                                                 || kazoouser.call_recording.inbound.onnet.enabled);


                user.callrecord_external= call_recarding_enabled && call_recarding_outbound_offnet_enabled
                                                            && call_recarding_inbound_offnet_enabled
                                                        
                                                        &&( kazoouser.call_recording.inbound.offnet.enabled 
                                                            || kazoouser.call_recording.outbound.offnet.enabled);
                if (typeof user.callrecord_internal  ==='undefined')
                 user.callrecord_internal=  false;
                  if (typeof user.callrecord_external  ==='undefined')
                 user.callrecord_external=  false;
                for(const number of user.text_permissions) {
                    if(phone_nums_dict.users.hasOwnProperty(user._id)) {
                        // const index = phone_nums_dict.users[user._id].findIndex(e => e === number.phone_number);
                        // if(index !== -1) {
                        //     phone_nums_dict.users[user._id].splice(index, 1);
                        // }
                        phone_nums_dict.users[user._id] = phone_nums_dict.users[user._id].filter(e => e !== number.phone_number);
                    }
                }

                for(const number of phone_nums_dict.all) {
                    if(typeof user.text_permissions.find(e => e.phone_number === number) === "undefined") {
                        user.text_permissions.push({
                            phone_number: number,
                            text_permissions_level: "unset"
                        });
                    }

                }

                if(phone_nums_dict.users.hasOwnProperty(user._id)) {
                    for(const number of phone_nums_dict.users[user._id]) {
                        user.text_permissions.push({
                            phone_number: number,
                            text_permissions_level: "unset"
                        });
                    }
                }

                const managers =!user.assigned_managers? 0 :user.assigned_managers.length;
                //This field is used for the "remove-manager" select in the admin-content-row.
                //The field saves the original manager so that if the manager changes we still
                //have access to the original value (v-model will overwrite it otherwise).
                user.original_managers = [];
               // user.assigned_managers=[];
                user.update_status = false;
                for(var i=0; i<managers; i++){
                    for(const manager of managers_list) {
                         if(user.assigned_managers[i] == manager._id) {
                            user.original_managers.push(manager);
                            user.assigned_managers[i] = manager;
                        }
                    }
                }
                if (user.original_managers.length<=0) 
                    user.assigned_managers=[];


            }
            return response;
        }

        updateUsers(response) {
             debugger
            const updated_users = this.processUsers(response);
            let updated_users_array = []
            for(const user of this.$data.users) {
                let updated_user = updated_users.find(e => {
                    return e._id === user._id;
                });
                if (updated_user)
                updated_users_array.push((updated_user) as never);
                else 
                updated_users_array.push((user) as never);
            }
         //   this.$data.users = [];
           this.$data.users = updated_users_array;

          
        }


}
